/**
 * @file Discover Album Folder Purchase view.
 */

import React from 'react';

import AlbumFolderPurchaseSummaryContainer from '../../containers/purchase/album-folder-purchase/AlbumFolderPurchaseSummaryContainer';

const AlbumFolderPurchaseSummaryView = props => (
  <AlbumFolderPurchaseSummaryContainer {...props} />
);

export default AlbumFolderPurchaseSummaryView;
